import type { Account } from "query/graphql"

export const getDisplayName = (user: Pick<Account, "name" | "address">) => {
  return Boolean(user.name) ? user.name : user.address
}
